import React from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

interface PanelProps {
  variant: 'blue' | 'light' | 'dark';
}

const Panel: React.FC<PanelProps> = ({ variant, children, ...rest }) => {
  let colourStyles = [];
  switch (variant) {
    case 'blue':
      colourStyles = [tw`bg-blue text-gray-50`];
      break;
    case 'light':
      colourStyles = [tw`bg-gray-50 text-gray-800`];
      break;
    case 'dark':
      colourStyles = [tw`bg-blue-900 text-gray-50`];
      break;
  }

  return (
    <div css={[tw`py-12 my-12`, ...colourStyles]} {...rest}>
      <div tw="container">{children}</div>
    </div>
  );
};

export default Panel;
